module.exports = __webpack_public_path__ + "static/ongress-logo-e5a376f0193996f16165f083dd882839.jpeg";